// import type { ArticleParameters } from '../../api/api'

import { ArticleList } from '../../pages/ArticleList'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_app/articles/')({
  component: ArticleList,
})